<div fxLayout="row" fxLayout.lt-md="column" class="card" [ngStyle]="{'width': '100vw'}"
    [ngClass]="currentIdPillar !== null ? 'on-viewing-pillar':null">
    <div *ngFor="let pillar of pillarList" routerLink="/pillar/{{pillar.id}}"
        [fxHide]="pillar.id != currentIdPillar ? 'false' :'true'" [fxFlex]="currentIdPillar !== null ? '33.3' : 25"
        fxLayout="column" class="pointer pillar-style" [ngStyle]="{'background-color': pillar.cor}">

        <div class="background-img" fxLayout="column" fxLayoutAlign="center center" [ngStyle]="{'background-image': 'url(' + storageUrl + (currentIdPillar !== null ? pillar.bannerPath : pillar.thumbPath) + ')',
                        'background-position': currentIdPillar !== null ? 'center center': '',
                        'background-color': currentIdPillar !== null ? pillar.cor + '99': '',
                        'background-repeat': currentIdPillar !== null ? 'no-repeat': '',
                        'background-blend-mode': currentIdPillar !== null ? 'multiply': '',
                        'background-size': currentIdPillar !== null ? 'cover': ''}">
            <span class="card-title">{{pillar.bannerSubTitulo}}</span>
        </div>


        <div class="card-footer" fxLayoutAlign="center center" fxLayout="column" fxLayoutAlign="center center">
            <div fxLayout="row" class="card-footer-color" fxFlexFill fxLayoutGap="20px" fxLayoutGap.lt-md="5px"
                fxLayoutAlign="center center">
                <img src="./assets/img/Ativo 1@3x@2x.png">
                <span class="title">{{pillar.bannerTitulo}}</span>
            </div>

            <div fxLayout="column" fxLayoutGap="20px" class="more-content" fxLayoutAlign="center center">
                <span class="description">{{pillar.secaoTitulo}}</span>
                <app-button [fontFamily]="'Museo Sans'" [txt]="'SAIBA MAIS'" [btnClass]="'btn-white btn-pillar-list'">
                </app-button>
            </div>
        </div>
    </div>
</div>
